import React, { useState } from 'react';
import Header from './Header';
import useModels from '../../api/models';
import { mapSize } from '../../general';

export default ({ match }) => {
  const { type, category } = match.params;
  const [viewSize, setViewSize] = useState(5);
  const models = useModels(type, category, viewSize);
  return (
    <>
      <Header match={match} viewSize={viewSize} setViewSize={setViewSize} />
      <div className={mapSize(viewSize)}>
        {models}
      </div>
    </>
  );
};
